export default __webpack_public_path__ + "static/anus-acfdf0ccfba74da06bf51e907c8465fa.svg";